import React, { useState, useEffect } from "react";
import "../../../App.css";
import { useDispatch, useSelector } from "react-redux";
import {
  user_settings_post,
  get_user_settings,
} from "../../../redux/authslice";
import { Flip, toast } from "react-toastify";

const SettingsPage = () => {
  const dispatch = useDispatch();
  const [settingsDetails, setSettingsDetails] = useState({
    daily_reminder: "",
    plan_renew: "",
    desktop_notification: "",
    email_notification: "",
    appearance: "",
    two_factor: "",
  });

  const [btnDisable, setBtnDisable] = useState(true);

  const { userSettings } = useSelector((state) => state.counter);

  useEffect(() => {
    dispatch(get_user_settings());
  }, [dispatch]);

  useEffect(() => {
    if (userSettings) {
      setSettingsDetails({
        daily_reminder: userSettings?.daily_reminder,
        plan_renew: userSettings?.plan_renew,
        desktop_notification: userSettings?.desktop_notification,
        email_notification: userSettings?.email_notification,
        two_factor: userSettings?.two_factor,
        appearance:
          userSettings?.appearance === "DARK"
            ? "Dark"
            : userSettings?.appearance === "LIGHT"
            ? "Light"
            : userSettings?.appearance === "SYSTEM"
            ? "System Default"
            : "Light",
      });
    }
  }, [userSettings]);

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setSettingsDetails((prevState) => ({
      ...prevState,
      [id]: checked,
    }));
    setBtnDisable(false);
  };

  const handleAppearanceChange = (e) => {
    setSettingsDetails((prevState) => ({
      ...prevState,
      appearance: e.target.value,
    }));
    setBtnDisable(false);
  };

  const handleSave = () => {
    const {
      daily_reminder,
      plan_renew,
      desktop_notification,
      email_notification,
    } = settingsDetails;

    if (
      (daily_reminder || plan_renew) &&
      !(desktop_notification || email_notification)
    ) {
      toast.warn(
        "You must select either Desktop Notification or Email Notification.",
        {
          position: "top-center",
          autoClose: 1200,
          fontSize: 10,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Flip,
        }
      );
      return;
    }
    dispatch(user_settings_post({ settingsDetails, dispatch }));
    setBtnDisable(true);
  };

  return (
    <>
      <section className="foundation-all">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="setting">
                <div className="settings-row">
                  <p className="setting-heading1">My notifications</p>
                  <div className="div-save">
                    <button
                      className="div-save-bt-setting"
                      onClick={handleSave}
                      disabled={btnDisable}
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className="notify">
                  <p className="setting-heading2">Notify me when...</p>
                  <p className="setting-heading3">About notifications?</p>
                </div>
                <ul className="checkbox-list notify-me">
                  <li>
                    <input
                      type="checkbox"
                      id="daily_reminder"
                      checked={settingsDetails?.daily_reminder}
                      onChange={handleCheckboxChange}
                    />
                    <p className="text1">Daily Quiz Reminder</p>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      id="plan_renew"
                      checked={settingsDetails?.plan_renew}
                      onChange={handleCheckboxChange}
                    />
                    <p className="text1">3 days before plan auto-renewal</p>
                  </li>
                </ul>
                <div className="desktop-notify">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="desk-notify1 mb-0">Desktop notifications</p>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="desktop_notification"
                        checked={settingsDetails?.desktop_notification}
                        onChange={handleCheckboxChange}
                      />
                    </div>
                  </div>
                  <p className="desk-notify2">
                    Receives desktop notifications related to your quiz
                    reminders
                  </p>
                </div>
                <div className="desktop-notify">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="desk-notify1 mb-0">Email notifications</p>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="email_notification"
                        checked={settingsDetails?.email_notification}
                        onChange={handleCheckboxChange}
                      />
                    </div>
                  </div>
                  <p className="desk-notify2">
                    Receive daily updates through email
                  </p>
                </div>
              </div>
              <div className="setting">
                <p className="setting-heading1">Other settings</p>
                {/* <div className="desktop-notify">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="desk-notify1 mb-0">Appearance</p>
                    <div className="dropdown">
                      <select
                        className="light-select"
                        value={settingsDetails?.appearance}
                        onChange={handleAppearanceChange}
                      >
                        <option value="Light">Light</option>
                        <option value="Dark">Dark</option>
                      </select>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li>
                          <a className="dropdown-item" href="#">
                            Light
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            Dark
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            System Default
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="desk-notify2">
                    Customize how your theme looks on your device
                  </p>
                </div> */}
                <div className="desktop-notify">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="desk-notify1 mb-0">
                      Two-factor authentication
                    </p>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="two_factor"
                        checked={settingsDetails?.two_factor}
                        onChange={handleCheckboxChange}
                      />
                    </div>
                  </div>
                  <p className="desk-notify2">
                    Keep your account secure by enabling 2FA via SMS or using a
                    temporary one time passcode
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="all-dasboard">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="question-box"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SettingsPage;
